import { render } from "./ItemDetails.vue?vue&type=template&id=5c1fc6c8&scoped=true"
import script from "./ItemDetails.vue?vue&type=script&lang=js"
export * from "./ItemDetails.vue?vue&type=script&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=5c1fc6c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hobbes\\Desktop\\abounddata-vue-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1fc6c8"]])

export default __exports__